import React, { useEffect, useState } from 'react';

import ArticleFeedItem, { type ArticleFeedItemProps } from '@components/FeedItems/ArticleFeedItem';
import type { ReadingStatProps } from '@hooks/useBlueConicPersonalizedReadingHub';
import type { Article } from '@interfaces/homepage';
import { getBlueconicRecommendations } from '@utils/blueconic/recommendations';

import MyTISection from './Section';

const MINIMUM_RECOMMENDED_ARTICLES = 2;

const MyTIRecommendedArticles = ({ recommendedArticles }: ReadingStatProps) => {
  const [articleRecommendation, setArticleRecommendation] = useState<Article[]>([]);

  useEffect(() => {
    const fetchBlueconicRecommendations = async () => {
      try {
        const blueconicRecommendations: Article[] = await getBlueconicRecommendations();

        if (blueconicRecommendations.length >= MINIMUM_RECOMMENDED_ARTICLES) {
          setArticleRecommendation(blueconicRecommendations);
        } else {
          setArticleRecommendation(recommendedArticles as unknown as Article[]);
        }
      } catch (error) {
        console.error('Error fetching mid-article recommendations from BlueConic:', error);
      }
    };

    fetchBlueconicRecommendations();
  }, [recommendedArticles]);

  return (
    <MyTISection
      hasBorder={false}
      highlight="Label"
      subtitle="Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos."
      title="Recommended Articles"
    >
      {articleRecommendation.map((article: Article) => (
        <ArticleFeedItem key={article.id} {...(article as ArticleFeedItemProps)} />
      ))}
    </MyTISection>
  );
};

export default MyTIRecommendedArticles;
